module.exports = __webpack_public_path__ + "img/pr-2.49acb01e.png";